import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { FedExShipmentDto } from 'dtos/fedEx'
import { OhioBuildABoxBundleDto, OhioBuildABoxBundleVehicleDto, OhioBuildABoxDto, OhioBuildABoxQueryParams } from 'dtos/ohioBuildABoxes'
import { download, URIQuery } from 'utils'

const baseUrl = (): string => '/api/ohio-build-a-boxes'
const ohioBuildABoxGuidUrl = (guid: string) => `${baseUrl()}/${encodeURIComponent(guid)}`
const ohioBuildABoxBundleGuidUrl = (guid: string) => `${baseUrl()}/ohio-build-a-box-bundles/${encodeURIComponent(guid)}`

export const getOhioBuildABoxes = (queryParams: OhioBuildABoxQueryParams) =>
  apiClient.get<ApiResponse<OhioBuildABoxDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)

export const getOhioBuildABox = (ohioBuildABoxGuid: string) =>
  apiClient.get<ApiResponse<OhioBuildABoxDto>>(ohioBuildABoxGuidUrl(ohioBuildABoxGuid)).then(res => res.data)

export const createOhioBuildABox = () => apiClient.post<ApiResponse<OhioBuildABoxDto>>(baseUrl()).then(res => res.data)

export const deleteOhioBuildABox = (ohioBuildABoxGuid: string) => apiClient.delete<undefined>(ohioBuildABoxGuidUrl(ohioBuildABoxGuid)).then(res => res.data)

export const lockOhioBuildABox = (ohioBuildABoxGuid: string) =>
  apiClient.put<ApiResponse<OhioBuildABoxDto>>(`${ohioBuildABoxGuidUrl(ohioBuildABoxGuid)}/lock`).then(res => res.data)

export const unlockOhioBuildABox = (ohioBuildABoxGuid: string) =>
  apiClient.put<ApiResponse<OhioBuildABoxDto>>(`${ohioBuildABoxGuidUrl(ohioBuildABoxGuid)}/unlock`).then(res => res.data)

export const createOhioBuildABoxBundle = (ohioBuildABoxGuid: string, data: OhioBuildABoxBundleDto) =>
  apiClient.post<ApiResponse<OhioBuildABoxBundleDto>>(`${ohioBuildABoxGuidUrl(ohioBuildABoxGuid)}/ohio-build-a-box-bundles`, data).then(res => res.data)

export const updateOhioBuildABoxBundle = (data: OhioBuildABoxBundleDto) =>
  apiClient.put<ApiResponse<OhioBuildABoxBundleDto>>(`${baseUrl()}/ohio-build-a-box-bundles`, data).then(res => res.data)

export const deleteOhioBuildABoxBundle = (ohioBuildABoxBundleGuid: string) =>
  apiClient.delete<undefined>(ohioBuildABoxBundleGuidUrl(ohioBuildABoxBundleGuid)).then(res => res.data)

export const lockOhioBuildABoxBundle = (ohioBuildABoxBundleGuid: string) =>
  apiClient.put<ApiResponse<OhioBuildABoxBundleDto>>(`${ohioBuildABoxBundleGuidUrl(ohioBuildABoxBundleGuid)}/lock`).then(res => res.data)

export const unlockOhioBuildABoxBundle = (ohioBuildABoxBundleGuid: string) =>
  apiClient.put<ApiResponse<OhioBuildABoxBundleDto>>(`${ohioBuildABoxBundleGuidUrl(ohioBuildABoxBundleGuid)}/unlock`).then(res => res.data)

export const getOhioBuildABoxBundleVehicles = (ohioBuildABoxBundleGuid: string) =>
  apiClient.get<ApiResponse<OhioBuildABoxBundleVehicleDto[]>>(`${ohioBuildABoxBundleGuidUrl(ohioBuildABoxBundleGuid)}/vehicles`).then(res => res.data)

export const manageOhioBuildABoxBundleVehicles = (ohioBuildABoxBundleGuid: string, data: OhioBuildABoxBundleVehicleDto[]) =>
  apiClient.put<ApiResponse<OhioBuildABoxBundleVehicleDto[]>>(`${ohioBuildABoxBundleGuidUrl(ohioBuildABoxBundleGuid)}/vehicles`, data).then(res => res.data)

export const updateFedExOutboundLabel = (ohioBuildABoxGuid: string, data: FedExShipmentDto) =>
  apiClient.put<ApiResponse<FedExShipmentDto>>(`${ohioBuildABoxGuidUrl(ohioBuildABoxGuid)}/fedex/outbound`, data).then(res => res.data)

export const updateFedExReturnLabel = (ohioBuildABoxGuid: string, data: FedExShipmentDto) =>
  apiClient.put<ApiResponse<FedExShipmentDto>>(`${ohioBuildABoxGuidUrl(ohioBuildABoxGuid)}/fedex/return`, data).then(res => res.data)

export const generateCombinedOhioCoverLetter = (ohioBuildABoxGuid: string) =>
  apiClient.get<string>(`${ohioBuildABoxGuidUrl(ohioBuildABoxGuid)}/generate-ohio-cover-letter`).then(res => {
    download(res.data, 'OhioCoverLetters.pdf', 'application/pdf')
  })

export const generateOhioCoverLetter = (ohioBuildABoxBundleGuid: string) =>
  apiClient.get<string>(`${ohioBuildABoxBundleGuidUrl(ohioBuildABoxBundleGuid)}/generate-ohio-cover-letter`).then(res => {
    download(res.data, 'OhioCoverLetter.pdf', 'application/pdf')
  })

export const getOhioTitleOwnerNames = () => apiClient.get<ApiResponse<string[]>>(`${baseUrl()}/ohio-title-owner-names`).then(res => res.data)
